import { useParams } from "react-router-dom";
import { useEffect } from "react";
import ProposalGenerationChat from "./ProposalGenerationChat.tsx";
import { useProposalGenerationStore } from "./store/ProposalGenerationStore";
import AtomAssistPageLoad from "src/views/assistant/components/AtomAssistPageLoad";
import { useSetProposalGenerationConfig } from "src/views/assistant/hooks/useProductConfig";
import { useChatStore } from "src/views/assistant/stores/ChatStore";

interface ProposalGenerationChatPageParams {
  proposal_generation_run_id: string;
  dialogueId: string;
}

const ProposalGenerationChatPage = () => {
  const {
    proposal_generation_run_id: runIdParam,
    dialogueId: dialogueIdParam,
  } = useParams<ProposalGenerationChatPageParams>();

  const proposalGenerationRunId = runIdParam ? Number(runIdParam) : undefined;
  const dialogueId = dialogueIdParam ? Number(dialogueIdParam) : undefined;

  // get initialUserMessage from chat store (set by splash page)
  const { initialUserMessage } = useChatStore();

  // set the proposal generation run ID and dialogue ID in the store
  useEffect(() => {
    if (proposalGenerationRunId) {
      useProposalGenerationStore.setState({ runId: proposalGenerationRunId });
    }
    if (dialogueId) {
      useProposalGenerationStore.setState({ dialogueId });
    }
  }, [proposalGenerationRunId, dialogueId]);

  // Set product configuration for Proposal Generation
  useSetProposalGenerationConfig();

  if (!proposalGenerationRunId || !dialogueId) {
    return <AtomAssistPageLoad />;
  }

  return (
    <ProposalGenerationChat
      proposalGenerationRunId={proposalGenerationRunId}
      dialogueId={dialogueId}
      initialUserMessage={initialUserMessage}
    />
  );
};

export default ProposalGenerationChatPage;
